export default __webpack_public_path__ + "static/bg-email-automation--mobile-e00d1f232dafc003a2261e77d5a9e374.jpg";